/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reels': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M5.754 0h8.492c1.58 0 3.018.645 4.06 1.68A5.682 5.682 0 0 1 20 5.72v8.562a5.687 5.687 0 0 1-1.69 4.035l-.003.003a5.755 5.755 0 0 1-4.06 1.68H5.755a5.762 5.762 0 0 1-4.064-1.68l-.04-.044A5.68 5.68 0 0 1 0 14.281V5.719c0-1.573.647-3.003 1.69-4.04A5.752 5.752 0 0 1 5.754 0Zm9.23 5.049.012.018h3.537a4.306 4.306 0 0 0-1.225-2.391 4.336 4.336 0 0 0-3.062-1.266h-1.452l2.19 3.639Zm-1.635.018L11.146 1.41h-4.83l2.228 3.657h4.805Zm-6.454 0L4.74 1.528a4.337 4.337 0 0 0-2.048 1.148 4.311 4.311 0 0 0-1.225 2.39h5.428Zm11.687 1.41H1.418v7.805c0 1.167.473 2.23 1.238 3.008l.036.034a4.34 4.34 0 0 0 3.062 1.268h8.492a4.334 4.334 0 0 0 3.06-1.265l.004-.003a4.282 4.282 0 0 0 1.272-3.042V6.476ZM8.342 8.943l4.394 2.84a.632.632 0 0 1 .021 1.058l-4.375 2.567a.638.638 0 0 1-.406.143.638.638 0 0 1-.64-.637v-5.45h.003a.641.641 0 0 1 1.004-.52v-.001Z" _fill="#fff" fill-rule="evenodd"/>'
  }
})
